import React from 'react';

const reviews = [
  {
    name: "Alvini Lim",
    title: "Technical Founder",
    company: "Dimensional",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    review:
      "The training program drastically improved our team's communication with German clients. We've seen a 40% increase in successful deals since completing it.",
  },
  {
    name: "John Doe",
    title: "CEO",
    company: "Tech Innovations",
    image: "https://randomuser.me/api/portraits/men/45.jpg",
    review:
      "Impressive curriculum and professional trainers. Our expansion into the German market was seamless thanks to this program.",
  },
  {
    name: "Jane Smith",
    title: "Marketing Head",
    company: "Global Ventures",
    image: "https://randomuser.me/api/portraits/women/50.jpg",
    review:
      "Our marketing campaigns in Germany are more effective now. We understand cultural nuances better, and it shows in our results.",
  },
  {
    name: "Lena Müller",
    title: "Project Manager",
    company: "Bavaria Tech",
    image: "https://randomuser.me/api/portraits/women/60.jpg",
    review:
      "As a native German speaker, I was impressed by how well the training matched real-world usage. Great for cross-border collaboration!",
  },
  {
    name: "Carlos Ortega",
    title: "Operations Lead",
    company: "Nova Logistics",
    image: "https://randomuser.me/api/portraits/men/52.jpg",
    review:
      "We needed our staff to quickly get up to speed with German for a partnership. This program delivered exactly what we needed—fast, effective, and engaging.",
  },
];


const Carousel = () => {
  return (
    <div className="w-[90%] mx-auto flex flex-col item-center  mt-20 mb-20">
      {/* Heading */}
      <h1 className="text-3xl md:text-5xl text-[#FF5B64] font-bold ">
        How We Helped Businesses Succeed <br />
        <span className="text-black">with German Language Training</span>
      </h1>

      {/* Carousel Wrapper */}
      <div className="relative w-full  max-w-full  mt-8 overflow-hidden ">
        <div className="flex space-x-6 overflow-x-auto snap-x snap-mandatory scrollbar-hide px-4">
          {reviews.map((review, index) => (
            <div key={index} className="flex-none  pb-5 w-80 snap-center">
              <div className="bg-white border-1 border-zinc-200  shadow-xl rounded-xl p-6 flex flex-col ">
                <img src="/quote.png" className='w-12 h-12' alt="" />
                <p className="text-gray-600">{review.review}</p>
                <div className="mt-6 flex items-center space-x-4">
                  <img
                    src={review.image}
                    alt={review.name}
                    className="w-14 h-14 rounded-full object-cover"
                  />
                  <div className="text-left">
                    <p>{review.name}</p>
                    <p className="text-sm text-gray-500">{review.title}</p>
                    <p className="text-sm text-gray-500">{review.company}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
